import {
  aLogMappingOptions,
  mockLogMappingOptionsQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockLogMappingOptionsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          logMappingOptions: aLogMappingOptions(
            {},
            new Set<string>([
              'logFormatOptions',
              'parsingPatternOptions',
              'recordTypeOptions',
            ])
          ),
        },
      });
    }
  ),
];
